<div class="modal-header">
  <h4 class="modal-title">{{ 'csv.title' | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    (click)="modalRef.close()"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body">
  <p>{{ 'csv.text' | translate }}</p>
  <div
    class="alert alert-info alert-dismissible fade show mb-4 mt-4"
    role="alert"
  >
    <span>{{ 'csv.info1' | translate }}</span>
    <a (click)="getTemplate()">{{ 'csv.infoLink' | translate }}</a>
    <span>{{ 'csv.info2' | translate }}</span>
    <a #defaultTemplateLink class="d-none" href="assets/csv_template.csv"
      >csv.infoLink2</a
    >
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="modalRef.close()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="float-end">
    <div class="form-check">
      <input
        #clearBox
        class="form-check-input"
        type="checkbox"
        value=""
        id="flexCheckDefault"
      />
      <label class="form-check-label" for="flexCheckDefault">
        {{ 'csv.clear_existing' | translate }}
      </label>
    </div>
  </div>
  <a (click)="fileInput?.click()">
    <span class="material-symbols-outlined text-secondary">upload</span>
    <span>{{ 'csv.upload_file' | translate }}</span>
  </a>
  <input
    #fileInput
    (change)="filesChanged($event)"
    class="d-none"
    type="file"
    accept=".csv"
  />
  @for (file of fileNames; track file; let i = $index) {
    <div
      class="alert alert-primary alert-dismissible fade show pt-1 pb-1 mt-2 col-12"
    >
      {{ file }}
      <button
        (click)="removeFile(i)"
        type="button"
        class="btn-close"
        style="padding-top: 0; top: -1px"
        aria-label="Remove"
      ></button>
    </div>
  }
  <app-error [error]="error"></app-error>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="modalRef.close()"
  >
    {{ 'close' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!isSaveable"
    (click)="save()"
    [ladda]="loading"
  >
    {{ 'save' | translate }}
  </button>
</div>
